<template>
  <ModuleWrapper :moduleId="moduleId" :image="imageSrcPath('assets/branding/logo.svg')" title="Social Media Thumbnail">
    <template #main>
      <ImageUploadButton
        label="This image will display when you share your event registration page link online. Upload a PNG or JPG"
        :image="thumbnailURL"
        :acceptedTypes="['.png', '.jpg', '.jpeg', '.webp']"
        :s3BucketPath="s3BucketPath"
        :filestackIntent="filestackIntent"
        @changeImageUrl="handleImageUrlChange"
      />
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';
import ImageUploadButton from '../components/ImageUploadButton.vue';

import { STATIC_ASSETS } from '@/constants';

export default {
  name: 'SocialMediaThumbnail',
  components: {
    ModuleWrapper,
    ImageUploadButton
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    }),
    ...mapGetters('org', {
      getCurrentOrg: 'getCurrentOrg'
    }),
    s3BucketPath() {
      if (this.$route.params.templateId) {
        return `${STATIC_ASSETS.SOCIAL_MEDIA_THUMBNAIL_PATH}/organization/${this.getCurrentOrg?.id}/`;
      }
      if (this.$route.name === 'RepeatingEventLookAndFeel' && this.$route.params.seriesId) {
        return `${STATIC_ASSETS.SOCIAL_MEDIA_THUMBNAIL_PATH}/series/${this.$route.params.seriesId}/${STATIC_ASSETS.IMAGE_PATH}/`;
      }
      return `${STATIC_ASSETS.SOCIAL_MEDIA_THUMBNAIL_PATH}/events/${this.$route.params.eventId}/`;
    },
    filestackIntent() {
      if (this.$route.params.templateId) {
        return { intent: 'public_image_org_asset', assetKind: 'image' };
      }
      if (this.$route.name === 'RepeatingEventLookAndFeel' && this.$route.params.seriesId) {
        return {
          intent: 'public_image_series_asset',
          assetKind: 'image',
          seriesId: this.$route.params.seriesId
        };
      }
      return { intent: 'public_image_event_asset', assetKind: 'image', event: this.$route.params.eventId };
    },
    thumbnailURL() {
      const moduleKeys = ['social_media_thumbnail'];
      const { social_media_thumbnail } = this.getInitialModuleData(moduleKeys);
      return social_media_thumbnail;
    }
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInEvent: 'setChangesMadeInEvent'
    }),
    handleImageUrlChange(url) {
      this.setChangesMadeInEvent({ social_media_thumbnail: url });
    }
  }
};
</script>
